"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _I18n = _interopRequireDefault(require("I18n"));

var WriteScopedButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(WriteScopedButton, _PureComponent);

  function WriteScopedButton() {
    (0, _classCallCheck2.default)(this, WriteScopedButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WriteScopedButton).apply(this, arguments));
  }

  (0, _createClass2.default)(WriteScopedButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          disabled = _this$props.disabled;
      var propsToPassDown = (0, _underscore.omit)(this.props, 'readOnly', 'dispatch');

      var button = _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, propsToPassDown, {
        disabled: disabled || readOnly
      }));

      if (readOnly) {
        return _react.default.createElement(_UITooltip.default, {
          title: _I18n.default.text('readOnly')
        }, button);
      }

      return button;
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        readOnly: _react.PropTypes.bool.isRequired,
        disabled: _react.PropTypes.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        disabled: false
      };
    }
  }]);
  return WriteScopedButton;
}(_react.PureComponent);

function mapStateToProps(state) {
  return {
    readOnly: (0, _Scopes.hasReadOnlyScope)(state)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(WriteScopedButton);

exports.default = _default;
module.exports = exports.default;